import { useMemo, useState } from "react";
import { getFanId } from "@/lib/fanzone";
import { toast } from "sonner";
import { Share2, Link2, ImageIcon, ExternalLink } from "lucide-react";

export default function ShareCardPanel({ kind, text, refreshKey = 0 }) {
  const fanId = getFanId();
  const backend = process.env.REACT_APP_BACKEND_URL;
  const [broken, setBroken] = useState(false);
  const v = useMemo(() => Date.now(), [refreshKey]);
  const img = `${backend}/api/fanzone/og/${kind}/${fanId}.png?v=${v}`;
  const shareUrl = `${backend}/api/fanzone/share/${kind}/${fanId}`;
  const tweetHref = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(shareUrl)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Share link copied");
    } catch {
      toast.error("Couldn't copy — long-press the image instead");
    }
  };

  return (
    <div className="titans-card p-5 md:p-6" data-testid={`fz-share-${kind}`}>
      <div className="flex items-center gap-2 mb-3">
        <ImageIcon size={15} className="text-titans-blue" />
        <span className="font-display text-xl uppercase">Share Your Card</span>
      </div>
      {!broken && (
        <img
          key={v}
          src={img}
          alt="Shareable card"
          onError={() => setBroken(true)}
          data-testid={`fz-share-img-${kind}`}
          className="rounded-lg border border-[#E2E8F0] w-full max-w-[620px] shadow-md"
        />
      )}
      <div className="flex flex-wrap gap-2 mt-4">
        <a
          href={tweetHref}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`fz-share-x-${kind}`}
          className="inline-flex items-center gap-2 bg-[#0f1419] hover:bg-black text-white px-5 py-2.5 font-cond uppercase tracking-wider text-xs rounded-md"
        >
          <Share2 size={13} /> Post on X
        </a>
        <button
          onClick={copy}
          data-testid={`fz-share-copy-${kind}`}
          className="inline-flex items-center gap-2 border border-titans-blue text-titans-blue hover:bg-titans-blue hover:text-white px-5 py-2.5 font-cond uppercase tracking-wider text-xs rounded-md transition-colors"
        >
          <Link2 size={13} /> Copy Link
        </button>
        <a
          href={img}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`fz-share-png-${kind}`}
          className="inline-flex items-center gap-2 border border-[#CBD5E1] text-titans-silver hover:text-titans-blue hover:border-titans-blue px-5 py-2.5 font-cond uppercase tracking-wider text-xs rounded-md transition-colors"
        >
          <ExternalLink size={13} /> Open PNG
        </a>
      </div>
      <div className="font-cond uppercase tracking-wider text-[9px] text-titans-muted mt-3">
        The link unfurls into your card automatically when posted on X
      </div>
    </div>
  );
}
